// Friendly labels + chip colours for the day-status codes emitted by the
// payroll day-wise breakdown (hrms utils/salary.py attendance logs). Keeps the
// raw enum codes (SUNDAY_PAID, PAID_LEAVE, …) out of the UI: the Daily
// Attendance Breakdown modals on Payroll Records and My Payroll both render
// through this map.
export type DayStatusMeta = { label: string; cls: string };

const CHIP: Record<string, DayStatusMeta> = {
  PRESENT: { label: "Present", cls: "bg-green-100 text-green-700" },
  FULL_DAY: { label: "Present", cls: "bg-green-100 text-green-700" },
  HALF_DAY: { label: "Half Day", cls: "bg-yellow-100 text-yellow-700" },
  ABSENT: { label: "Absent", cls: "bg-red-100 text-red-700" },
  OVERTIME: { label: "Overtime", cls: "bg-purple-100 text-purple-700" },
  SUNDAY_PAID: { label: "Sunday", cls: "bg-sky-100 text-sky-700" },
  SATURDAY_PAID: { label: "Saturday", cls: "bg-sky-100 text-sky-700" },
  HOLIDAY_PAID: { label: "Holiday", cls: "bg-indigo-100 text-indigo-700" },
  PAID_LEAVE: { label: "Leave", cls: "bg-amber-100 text-amber-700" },
  HALF_DAY_LEAVE: { label: "Half-Day Leave", cls: "bg-amber-100 text-amber-700" },
  HALF_DAY_LEAVE_UNPAID: { label: "Half-Day Leave (Unpaid)", cls: "bg-orange-100 text-orange-700" },
  UNPAID_LEAVE: { label: "Unpaid Leave", cls: "bg-orange-100 text-orange-700" },
  WORK_FROM_HOME: { label: "WFH", cls: "bg-teal-100 text-teal-700" },
  NOT_JOINED: { label: "Not Joined", cls: "bg-gray-100 text-gray-500" },
};

export const dayStatusMeta = (status?: string | null): DayStatusMeta => {
  const key = (status || "").toUpperCase();
  if (CHIP[key]) return CHIP[key];
  // Unknown codes: prettify RAW_CODE → "Raw Code" rather than leaking enums.
  const label = key
    ? key
        .toLowerCase()
        .split("_")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : "—";
  return { label, cls: "bg-yellow-100 text-yellow-700" };
};
